import cx from 'classnames'
import React from 'react'
import { Checkbox, Form, FormItemProps } from '@commutifi-fe/ui'
import { useIntl } from 'locales/index'
import styles from './styles.module.scss'

export interface ICheckBoxInputProps extends FormItemProps {
  children: React.ReactNode
  className?: string
  bordered?: boolean
  tabIndex?: number
  disabled?: boolean
}

function CheckBoxInput({ children, className, name, bordered, tabIndex, ...otherFormItemProps }: ICheckBoxInputProps) {
  const intl = useIntl()
  const validateIsChecked = (_rule: any, value: boolean) => {
    if (!value) {
      return Promise.reject(intl.formatMessage({ id: 'required' }))
    }
    return Promise.resolve()
  }

  return (
    <div className={className}>
      <Form.Item
        name={name}
        valuePropName="checked"
        rules={[
          {
            validator: validateIsChecked
          }
        ]}
        {...otherFormItemProps}
      >
        <Checkbox
          tabIndex={tabIndex}
          disabled={otherFormItemProps.disabled}
          className={cx(styles['checkbox-input'], bordered && styles['checkbox-input--bordered'])}
        >
          {children}
        </Checkbox>
      </Form.Item>
    </div>
  )
}

export default CheckBoxInput
